import { URL_SEND_EMAIL } from '@/utils/constants';
import { ERROR, SendEmailError } from '@/utils/errors';
import { getIrrigationArea } from '@/utils/getIrrigationArea';
import { ICalculatorForm, IGroupedFormDTO, IIrrigationArea, IOrderForm } from '@/utils/interfaces';
import * as turf from "@turf/turf";
import axios from "axios";
import StatusCodes from "http-status-codes";
import Vue from 'vue';
import Vuex from 'vuex';
import { IWaterLine, IWaterSource } from './../utils/interfaces';

Vue.use(Vuex);

const STATE = {
  isFormOpen: false,
  isModalVisible: false,
  calculatorForm: {
    valid: false,
    fieldLength: 0,
    fieldWidth: 0,
    fieldOrientation: 0,
    bedsSpacing: 0,
    cropSpacing: 0,
    distWaterSource: 0,
    slopeOrientation: 0,
    solarOrientation: 0,
    cropType: "",
    soilType: "",
    irrigationType: "",
    waterConsumption: 0,
    waterSource: "",
    waterSourcePipeDiameter: 0,
    minimalPressure: 0,
    maximumPressure: 0,
    doYouHaveAPump: false,
    pumpPreference: "",
  },
  irrigationArea: Array<IIrrigationArea>(),
  isSendEmailSuccessful: false,
  orderForm: null,
  waterSource: {
    lat: null,
    lng: null
  }
}

const mutations = {
  pushToIrrigationArea(state: any, irrigationArea: IIrrigationArea) {
    state.irrigationArea.push(irrigationArea)
  },
  toggleIsFormOpen(state: any) {
    state.isFormOpen = !state.isFormOpen
  },
  setCalculatorForm(state: any, calculatorForm: ICalculatorForm) {
    state.calculatorForm = calculatorForm;
  },
  setOrderForm(state: any, orderForm: IOrderForm) {
    state.orderForm = orderForm;
  },
  setCalculatorFormProperty(state: any, proprety: object) {
    state.calculatorForm[Object.keys(proprety)[0]] = Object.values(proprety)[0];
  },
  setWaterSource(state: any, waterSource: IWaterSource) {
    state.waterSource = waterSource
  }
}

export default new Vuex.Store({
  state: STATE,
  mutations,
  getters: {
    lastIrrigationArea: (state: any) => {
      return state.irrigationArea.pop()
    },
    groupedForm: (state: any): IGroupedFormDTO => {
      return { calculatorForm: state.calculatorForm, orderForm: state.orderForm }
    }
  },
  actions: {
    addToIrrigationArea(context: any, feature: turf.AllGeoJSON) {
      const irrigationArea = getIrrigationArea(feature)
      context.commit('setCalculatorFormProperty', { fieldLength: irrigationArea.length })
      context.commit('setCalculatorFormProperty', { fieldWidth: irrigationArea.width })
      context.commit('pushToIrrigationArea', irrigationArea)
    },
    commitWaterLine(context: any, waterLine: IWaterLine) {
      context.commit('setwaterLine', waterLine)
    },
    commitOrder(context: any, calculatorForm: ICalculatorForm) {
      context.commit('setCalculatorForm', calculatorForm)
    },
    commitWaterSource(context: any, waterSource: IWaterSource) {
      context.commit('setWaterSource', waterSource)
    },
    async sendEmail(context: any, orderForm: IOrderForm) {
      context.commit('setOrderForm', orderForm)

      try {
        const response = await axios.post(URL_SEND_EMAIL, this.getters.groupedForm)
        if (response.status === StatusCodes.OK) {
          this.state.isSendEmailSuccessful = true
        }
      } catch (error) {
        this.state.isSendEmailSuccessful = false
        throw new SendEmailError(ERROR.POST_SEND_EMAIL_FAIL)
      }
    }
  }
});
